import React from 'react';

import Skel from '../../components/skel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { driverTypeFromHistory } from '../../services/driver';
import HomologationErrorIndicator from './homologation-error';

import * as fmt from '../../utils/fmt';

import styles from './styles.css';

const LabelSubtitle = withStyles({
  root: {
    color: '#8B8B8D',
    textTransform: 'uppercase',
    fontSize: '12px',
  }
})(Typography);

const resolveDriverIdentity = (driver, history) => {
  const phones = driver.phones && driver.phones.map(rec => rec.phone).join(', ');
  const cityState = driver.city && driver.city.state.abbrev;

  return {
    name: history.driverName || driver.name || '-',
    cpf: fmt.cpf(history.driverCPF || driver.cpf || '') || '-',
    rg: history.driverRg || driver.rg || '-',
    birth: fmt.dateOnly(history.driverBirth || driver.birth) || '-',
    mother: history.driverMother || driver.mother || '-',
    phone: history.driverPhone || phones || '-',
    uf: history.driverRgState || cityState || '-',
  };
};

const resolveDriverLicense = (driver, history) => {
  const relationshipType = driver.driverRelationshipType;
  const relationshipDesc = relationshipType && relationshipType.description;

  return {
    cnh: history.driverCNH || driver.cnh || '-',
    cnhSecurity: history.driverCNHSecurity || driver.cnhSecurity || '-',
    cnhCategory: history.driverCNHCategory || driver.cnhCategory || '-',
    cnhValidity: fmt.dateOnly(history.driverCNHValidity || driver.cnhValidity) || '-',
    driverType: driverTypeFromHistory[history.driverKind] || relationshipDesc,
    hasDriverType: !!(driverTypeFromHistory[history.driverKind] || relationshipType),
  };
};

export default function NewDriverDetails({ driver = {}, history = {}, homologationError = null }) {
  const loading = !(driver.id || history.driverName);
  const identity = resolveDriverIdentity(driver, history);
  const license = resolveDriverLicense(driver, history);

  return <>
    <div className={styles.sectionTitleWrapper}>
      <Typography style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '0px' }}>
        Dados do Motorista
      </Typography>
      <hr style={{ margin: 0, borderColor: '#8B8B8D', borderWidth: '1px' }} />
    </div>

    <Grid
      spacing={24}
      container
      style={{ fontSize: '14px', fontWeight: 'bold', padding: '0rem 5px' }}
    >

      <Grid item sm={6}>
        <div>
          <LabelSubtitle variant="subtitle2">
            Nome Completo
          </LabelSubtitle>
          <Skel loading={loading}>{identity.name}</Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div>
          <LabelSubtitle variant="subtitle2">
            CPF
          </LabelSubtitle>
          <Skel loading={loading}>{identity.cpf}</Skel>
        </div>
      </Grid>

      { license.hasDriverType &&
        <Grid item sm={6}>
          <div>
            <LabelSubtitle variant="subtitle2">
              Tipo Motorista
            </LabelSubtitle>
            <Skel loading={loading}>{license.driverType}</Skel>
          </div>
        </Grid>
      }

      <Grid item sm={6}>
        <div>
          <LabelSubtitle variant="subtitle2">
            RG
          </LabelSubtitle>
          <Skel loading={loading}>{identity.rg}</Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div>
          <LabelSubtitle variant="subtitle2">
            Data de Nascimento
          </LabelSubtitle>
          <Skel loading={loading}>{identity.birth}</Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div>
          <LabelSubtitle variant="subtitle2">
            Nome da Mãe
          </LabelSubtitle>
          <Skel loading={loading}>{identity.mother}</Skel>
        </div>
      </Grid>

      <HomologationErrorIndicator error={homologationError} loading={loading} />

      <Grid item sm={6}>
        <div>
          <LabelSubtitle variant="subtitle2">
            CNH
          </LabelSubtitle>
          <Skel loading={loading}>{license.cnh}</Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div>
          <LabelSubtitle variant="subtitle2">
            Cód. Segurança CNH
          </LabelSubtitle>
          <Skel loading={loading}>{license.cnhSecurity}</Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div>
          <LabelSubtitle variant="subtitle2">
            Categoria
          </LabelSubtitle>
          <Skel loading={loading}>{license.cnhCategory}</Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div>
          <LabelSubtitle variant="subtitle2">
            Validade CNH
          </LabelSubtitle>
          <Skel loading={loading}>{license.cnhValidity}</Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div>
          <LabelSubtitle variant="subtitle2">
            Telefone
          </LabelSubtitle>
          <Skel loading={loading}>{identity.phone}</Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div>
          <LabelSubtitle variant="subtitle2">
            UF
          </LabelSubtitle>
          <Skel loading={loading}>{identity.uf}</Skel>
        </div>
      </Grid>

    </Grid>
  </>;
}
